import type { UiStrings } from '@/constants/ui-locale'

/** Primary header control that opens the mid-call invite modal (BRAI-785). */
export default function LiveInviteButton({
  t,
  onClick,
  testId = 'live-invite-members-button',
}: {
  t: UiStrings
  onClick: () => void
  testId?: string
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className="btn-primary inline-flex shrink-0 items-center gap-1 rounded-lg px-2 py-0.5 text-[11px] font-semibold sm:gap-1.5 sm:px-3 sm:py-1 sm:text-xs"
    >
      <InvitePersonPlusIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
      {t.liveInviteButton}
    </button>
  )
}

function InvitePersonPlusIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M15 12a4 4 0 100-8 4 4 0 000 8zM3 20a6 6 0 0112 0v1H3v-1zM19 8v2m0 0v2m0-2h2m-2 0h-2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
